import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
import { FilterBase } from '@/models/filter/FilterBase'

export interface ICoverageIterationState {
    status:string
    coverageIterations: Array<AloDbCoverageIteration>
    modifiedAdmCoverageIteration: AloDbCoverageIteration
    originalAdmCoverageIteration: AloDbCoverageIteration
    coverageIterationLoading: boolean
    adminFilter: FilterBase
}
  
const state:ICoverageIterationState = { 
    status: '',
    coverageIterations: [],
    modifiedAdmCoverageIteration: new AloDbCoverageIteration(),
    originalAdmCoverageIteration: new AloDbCoverageIteration(),
    coverageIterationLoading:false,
    adminFilter: new FilterBase()
}
  
export default state